import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "./ui/accordion"
import { useLanguage } from "../lib/LanguageContext"

export default function Faq() {
  const { t } = useLanguage()

  const FAQS = [
    { q: t("faq1_q"), a: t("faq1_a") },
    { q: t("faq2_q"), a: t("faq2_a") },
    { q: t("faq3_q"), a: t("faq3_a") },
    { q: t("faq4_q"), a: t("faq4_a") },
    { q: t("faq5_q"), a: t("faq5_a") },
    { q: t("faq6_q"), a: t("faq6_a") },
  ]

  return (
    <section id="faq" className="bg-ink-800 py-24">
      <div className="container mx-auto max-w-content px-6 sm:px-16">
        <h2 className="mb-12 font-display text-4xl font-bold text-paper-0">{t("faq_title")}</h2>
        <Accordion type="single" collapsible className="max-w-[760px]">
          {FAQS.map((item) => (
            <AccordionItem key={item.q} value={item.q}>
              <AccordionTrigger>{item.q}</AccordionTrigger>
              <AccordionContent>
                <p className="max-w-[640px]">{item.a}</p>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  )
}
